import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import MobileNav from "./MobileNav";
import VipModal from "../modals/VipModal";
import ChartBackdrop from "../common/ChartBackdrop";

export default function AppShell() {
  const [vipOpen, setVipOpen] = useState(false);
  return (
    <div className="ambient relative min-h-screen bg-[#0a0a0b]">
      <div className="grid-bg pointer-events-none fixed inset-0 opacity-40" />
      <ChartBackdrop className="!fixed" opacity={0.05} />
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        {Array.from({ length: 6 }).map((_, i) => (
          <span key={i} className="particle absolute bottom-0 h-1 w-1 rounded-full bg-white/40"
            style={{ left: `${8 + i * 16}%`, animationDelay: `${i * 1.4}s`, animationDuration: `${7 + i}s` }} />
        ))}
      </div>
      <Sidebar />
      <div className="relative z-10 lg:pl-64">
        <Topbar onVip={() => setVipOpen(true)} />
        <main className="min-h-[calc(100vh-57px)] px-4 pb-28 pt-6 md:px-8 lg:pb-10">
          <Outlet context={{ openVip: () => setVipOpen(true) }} />
        </main>
      </div>
      <MobileNav />
      <VipModal open={vipOpen} onClose={() => setVipOpen(false)} />
    </div>
  );
}
